// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"fa759856","201":"bc31ee3e","259":"234cf1ff","277":"e2c6995f","391":"bee6cd54","453":"981ba037","472":"347bd672"}[chunkId] + ".chunk.js";
};